module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki14_sp-577842122c2a37159423d655be59b01f.jpg";